const carModels = ['Model S', 'Model X', 'Model 3', 'Roadster', 'Energy'];

const NavMenu = () => `
<nav role="navigation">
    <div class="navigation-menu">
        <input class="checkbox" type="checkbox" />
        <div class="models" id="car-menu" role="list">
            ${carModels
              .map(
                (model, index) =>
                  `<li role="listitem"><a class="${
                    index === 0 ? 'model-item selected' : 'model-item'
                  }" href="/" role="link">${model}</a></li>`
              )
              .join('')}
        </div>
        <div class="hamburger-lines">
            <span class="line line-1"></span>
            <span class="line line-2"></span>
            <span class="line line-3"></span>
        </div>
    </div>
</nav>
`;

const Header = () => `
<header role="banner">
    <div class="logo-section">
        <a href="/" role="link">
            <img src="assets/images/tesla-logo.png" title="Logo" alt="logo" />
        </a>
    </div>
    ${NavMenu()}
</header>
`;

const mobileMenu = () => {
  const navMenu = document.querySelector('#car-menu');
  if (navMenu) {
    if (window.innerWidth > 768) {
      navMenu.classList.remove('mobile');
    } else {
      navMenu.classList.add('mobile');
    }
  }
};

// Prevent animation from triggering on page resize
window.addEventListener('resize', mobileMenu);
window.addEventListener('DOMContentLoaded', mobileMenu);

export default Header;
